














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SettingChooserExplorer extends Vue {
  @Prop() public label!: string;
  @Prop() public selector!: string;
  @Prop() public setter!: string;
  @Prop() public defaultValue!: string;
  @Prop() public addOption!: string;
  @Prop() public addMethod!: string;

  get options() {
    return this.$store.state.explorerOptions.availableOptions[this.selector];
  }

  get selected() {
    return this.$store.state.explorerOptions.availableOptions[this.selector][this.defaultValue].value;
  }

  set selected(value) {
    this.$store.commit(this.setter, { [this.selector]: value });
  }

  public async mounted() {
    this.$store.commit('setExplorerOptions',{ availableOptions: {
      provider: [ 
        { text: 'Subscan', value: 'subscan' },
        { text: 'Polkascan', value: 'polkascan'} 
      ], 
      chain: [
        { text: 'Kusama', value: 'kusama' },
        { text: 'Edgeware', value: 'edgeware' },
        { text: 'Darwinia', value: 'crab' },
      ]
    }}
    )
  }
}
